var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainSectionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.9401,
    height: 31.9401,
    rx: 15.9701,
    fill: "#8CBE26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3405 8.71094V23.2292",
    stroke: "white",
    strokeWidth: 1.45182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1627 9.07422V12.7038C10.1627 14.5186 12.3405 14.5186 12.3405 14.5186C12.3405 14.5186 14.5182 14.5186 14.5182 12.7038V9.07422",
    stroke: "white",
    strokeWidth: 1.45182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5995 14.5186V23.2295",
    stroke: "white",
    strokeWidth: 1.45182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7772 11.6146C21.7772 13.2182 20.8022 14.5182 19.5995 14.5182C18.3968 14.5182 17.4218 13.2182 17.4218 11.6146C17.4218 10.0109 18.3968 8.71094 19.5995 8.71094C20.8022 8.71094 21.7772 10.0109 21.7772 11.6146Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.45182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSectionIcon);
export default __webpack_public_path__ + "static/media/main-section-icon.26fff4f1641a0c5020be12621f5a974e.svg";
export { ForwardRef as ReactComponent };